import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { Typography, Button } from "antd";
import TestKeys from "./TestKeys.jsx";
import "./APITab.css"
import ApiBaseUrl from "./components/ApiBaseUrl.jsx";

const TestModePage = ({ setCurrentPage }) => {
  return (
    <div className="api-page">
      <div className="keys-section">
        <Typography.Title level={3} style={{ textAlign: "center" }}>
          Welcome to the Test Mode!
        </Typography.Title>
        <TestKeys />
        <Button
          type="primary"
          style={{ marginTop: "10px" }}
          onClick={() => setCurrentPage("prod")}
          className="settings-api-tab-btn"
        >
          Generate Production Access Keys
        </Button>
      </div>
      <div className="info-section">
        <ApiBaseUrl />
        <div className="info-box">
          <Typography.Title level={3}>Ready to Launch?</Typography.Title>
          <Typography.Text>
            If you are ready to start using Verigram technologies in production,
            simply press “Generate Production Access Keys” and follow the
            instructions
          </Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default TestModePage;
